import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";

import Layout from "../../components/layout/Layout";
import {
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Toolbar,
  Chip,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";

import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";

import Admin from "../../components/auth/Admin";
import Subscription from "../../actions/Subscription";
import Popup from "../../components/customHelpers/Popup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import AddOrganizationSubscription from "../../components/forms/addOrganizationSubscriptionService";
import { FiEdit } from "react-icons/fi";

const useStyles = makeStyles((theme) => ({
  activated: {
    color: "#2e7d32",
    fontWeight: "bold",
  },
  deactivated: {
    color: "#d32f2f",
    fontWeight: "bold",
  },
  image: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
  },
  expired: {
    color: "#d32f2f",
  },
}));
const headCells = [
  { id: "organization_name", label: "Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone" },
  { id: "startDate", label: "Start Date" },
  { id: "expiredDate", label: "Expired Date" },
  { id: "status", label: "Status", disableSorting: true },
  { id: "actions", label: "Actions", disableSorting: true },
];
const OrganizationSubscriptionPage = () => {
  const classes = useStyles();
  const history = useHistory();

  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewSubscription } = Subscription();
  const [organization, setOrganization] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [result, setResult] = useState(false);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  let location = useLocation();

  const { loading } = values;
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getSubscription();
  }, [value]);

  const getSubscription = () => {
    setValues({
      ...values,
      loading: true,
    });
    viewSubscription(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.subscription) {
        setValues({
          ...values,
          loading: false,
        });
        const modifiedData = data.subscription.organizationSubscriptions.map(
          (order) => ({
            ...order,
            organization_name: order.organization?.organization_name,
            phone: order.organization.phoneNo,
            email: order.organization.email,
            startDate: order.startDate,
            expiredDate: order.expiredDate,
            id: order.id,
          })
        );
        setResult(data.subscription);
        setOrganization(modifiedData);
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(organization, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["organization_name"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push("/admin/subscriptions");
              }}
            ></ArrowBackIcon>{" "}
            <span style={{ marginLeft: "6px" }}>
              Attached Organizations to{" "}
              <span
                style={{
                  color: "rgba(244,151,3,.8)",
                }}
              >
                {result?.name}
              </span>{" "}
              Subscription
            </span>
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search service"
              className="searchInput"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.organization_name}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phone}</TableCell>
                            <TableCell>{item.startDate}</TableCell>
                            <TableCell>{item.expiredDate}</TableCell>
                            <TableCell>
                              {new Date(item.expiredDate) < new Date() ? (
                                <Chip
                                  label="Expired"
                                  color="error"
                                  size="small"
                                />
                              ) : (
                                <Chip
                                  label="Active"
                                  color="success"
                                  size="small"
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {" "}
                              <Controls.ActionButton
                                color="primary"
                                title="Update dates"
                                onClick={() => {
                                  setOpenPopup(true);
                                  setRecordForEdit(item);
                                  setEdit(true);
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>{" "}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Add Subscription Service Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddOrganizationSubscription
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            getSubscription={getSubscription}
            edite={edite}
            id={recordForEdit?.id}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default OrganizationSubscriptionPage;
